module.exports = __webpack_public_path__ + "img/blimpy5.624d7d9b.jpg";